import React from "react";
import { Collapse, Nav, NavItem, NavLink } from "reactstrap";
import Inventory from "assets/icon/Inventory-gray-icon.svg";
import invontoryWhiteIcon from "../assets/icon/inventory-white-icon.svg";
import topWhiteArrow from "../assets/icon/top-white-arrow.svg";
import bottomPurpleArrow from "../assets/icon/bottom-purple-arrow.svg";
import cycleCount from "../assets/sidebar/cycle-count.svg";
import optimization from "../assets/sidebar/opti.svg";
import dashboardIconDark from "../assets/sidebar/dashboardIcon-dark.svg";
import dashboardIconLight from "../assets/sidebar/dashboardIcon-light.svg";
import productDark from "../assets/sidebar/productDark.svg";
import productLight from "../assets/sidebar/productLight.svg";
import purchaseOrderLight from "../assets/sidebar/purchaseOrderLight.svg";
import purchaseOrderDark from "../assets/sidebar/purchaseOrderDark.svg";
import { Link } from "react-router-dom";
import builderIcon from "../../src/assets/reports/builder.svg";

const ReportsSideBar = (props) => {
  const { title, toggles, menuactive, activeText, setActiveText } = props;
  const handleClick = (link) => {
    setActiveText(link);
  };
  return (
    <NavItem className="">
      <NavLink
        to="/reports-dashboard"
        className={`link-container ${
          location.pathname.startsWith("/reports")
            ? "active-btn "
            : "nav-button"
        }`}
        onClick={toggles}
      >
        <span>
          <img
            // className={
            //   location.pathname.startsWith("/reports")
            //     ? "workflow-img"
            //     : "workflow-text"
            // }
            src={
              location.pathname.startsWith("/reports")
                ? invontoryWhiteIcon
                : Inventory
            }
          />{" "}
          <span
            className={
              location.pathname.startsWith("/reports")
                ? "workflow-header"
                : "workflow-text"
            }
          >
            {title}
          </span>
        </span>
        <span className="work-flow-arrow">
          <img
            src={
              location.pathname.startsWith("/reports")
                ? topWhiteArrow
                : bottomPurpleArrow
            }
          />
        </span>
      </NavLink>
      <Collapse isOpen={location.pathname.startsWith("/reports")}>
        <Nav
          navbar
          vertical
          // style={{ marginLeft: "20px", marginBottom: "5px", marginTop: "5px" }}
        >
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/reports-dashboard"
                onClick={() => handleClick("/reports-dashboard")}
                style={{
                  color: activeText === "/reports-dashboard" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/reports-dashboard"
                          ? dashboardIconDark
                          : dashboardIconLight
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText === "/reports-dashboard" ? "600" : "",
                      }}
                    >
                      Dashboard
                    </span>
                  </div>
                  <div></div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/reports-schduler"
                onClick={() => handleClick("/reports-schduler")}
                style={{
                  color: activeText === "/reports-schduler" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/reports-schduler"
                          ? builderIcon
                          : builderIcon
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText === "/reports-schduler" ? "600" : "",
                      }}
                    >
                      Scheduler
                    </span>
                  </div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/reports-builder"
                onClick={() => handleClick("/reports-builder")}
                style={{
                  color: activeText === "/reports-builder" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/reports-builder"
                          ? builderIcon
                          : builderIcon
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText === "/reports-builder" ? "600" : "",
                      }}
                    >
                      Builder
                    </span>
                  </div>
                  <div></div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </NavItem>
  );
};

export default ReportsSideBar;
